import React from "react";

import { TimePicker, Toggle } from "@amphore-dev/amphore-lib";

import { getTranslatedDayName } from "@/utils/UWorkDays";

import { TDayName } from "@/types";

export interface IDaySettingsProps {
	day: TDayName;
	hours: string | undefined;
	isWorkingDay: boolean;
	onChange: (day: TDayName, hours: string, isWorkingDay: boolean) => void;
	settingsIndex?: number;
}

export const DaySettings: React.FC<IDaySettingsProps> = ({
	day,
	isWorkingDay,
	hours = "00:00",
	onChange,
}) => {
	return (
		<div className="row items-center justify-between gap-10">
			<Toggle
				label={getTranslatedDayName(day)}
				wrapperClassName="capitalize"
				checked={isWorkingDay}
				onChange={(checked) => onChange(day, hours, checked)}
			/>
			{isWorkingDay && (
				<div>
					<TimePicker
						value={hours}
						onChange={(value) =>
							onChange(day, value ?? "00:00", isWorkingDay)
						}
						disabled={!isWorkingDay}
					/>
				</div>
			)}
		</div>
	);
};
